import React, { useDeferredValue, useRef, useState } from "react";
import PageHeader from "../../components/PageHeader";
import CustomPagination from "../../components/CustomPagination";
import { Button, Collapse } from "react-bootstrap";
import { deleteConfirmation } from "../../utils";
import Filter from "./Filter";
import useLiveDataTable from "../../hooks/useLiveDataTable";
import { useGetBrokerQuery, useRemoveBrokerMutation } from "../../redux/services/BrokerService";
// Modals
import CreatePaydayModal from "./CreatePaydayModal";
import ViewPaydayModal from "./ViewPaydayModal";
import JobsModal from "./JobsModal";
import DocModal from "./DocModal";
import { useGetStatementsQuery, useRemoveStatementMutation } from "../../redux/services/StatementService";
import EditPayDayModal from "./EditPaydayModal";
import { usePdfExport } from "../../hooks/usePdfExport";
import PaydayStatement from "./PaydayStatement";


const defaultData = {
  id: '#payday-1',
  company: {
    name: 'ABC Trucking Inc.',
    email: 'accounts@abctrucking.com',
    phone: '(555) 123-4567',
  },
  driver: {
    name: 'Driver A',
    email: 'driver.a@email.com',
    phone: '(555) 987-6543',
    dlNumber: 'D12345678',
  },
  paymentDate: '2023-10-25',
  status: 'Paid',
  gross: 2550.00,
  expensesTotal: 350.00,
  net: 2200.00,
  jobs: [
    { id: 1, completedDate: '2023-10-15', pickup: 'Location A', dropoff: 'Location B', broker: 'Broker XYZ', rcNumber: 'RC1231', amount: 550.00 },
    { id: 2, completedDate: '2023-10-16', pickup: 'Location A', dropoff: 'Location B', broker: 'Broker XYZ', rcNumber: 'RC1232', amount: 500.00 },
    { id: 3, completedDate: '2023-10-18', pickup: 'Location A', dropoff: 'Location B', broker: 'Broker XYZ', rcNumber: 'RC1233', amount: 600.00 },
    { id: 4, completedDate: '2023-10-20', pickup: 'Location A', dropoff: 'Location B', broker: 'Broker XYZ', rcNumber: 'RC1234', amount: 450.00 },
    { id: 5, completedDate: '2023-10-22', pickup: 'Location A', dropoff: 'Location B', broker: 'Broker XYZ', rcNumber: 'RC1235', amount: 450.00 },
  ],
  expenses: [
    { id: 1, type: 'Fuel', amount: 200.00 },
    { id: 2, type: 'Insurance', amount: 100.00 },
    { id: 3, type: 'Factoring', amount: 50.00 },
  ],
};


const DriverStatement = () => {
  const {
    currentPage,
    perPage,
    q,
    searchQuery,
    setSearchQuery,
    handlePageChange,
    handlePerPageChange,
    onSearchKeyHandler,
    handleSearchBy,
    searchBy,
  } = useLiveDataTable();

  
  const statementRef = useRef(null);
  const { exportAsPdf, isPdfReady } = usePdfExport();

  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [query, setQuery] = useState(null);
  const params = useDeferredValue(query);

  const { data: data2, isFetching, refetch } = useGetStatementsQuery({
    id: '',
    pagination: `?page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}`
  })
  const statements = data2?.response?.data?.data
  const total = data2?.response?.data?.total;
  // 🔹 Static payday data
  const staticPaydays = [
    {
      id: "payday-1",
      driver: "Driver A",
      jobs: 1,
      datePaid: "N/A",
      totalGross: 487.0,
      totalExpenses: 0.0,
      netEarnings: 487.0,
      status: "Unpaid",
    },
  ];
  const [removeRequest] = useRemoveStatementMutation();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showJobsModal, setShowJobsModal] = useState(false);
  const [showDocModal, setShowDocModal] = useState(false);

  const [viewingPayday, setViewingPayday] = useState(null);
  const [viewingJobs, setViewingJobs] = useState([]);
  const [docModal, setDocModal] = useState({ title: "", content: "" });


  const handleDownloadPdf = (row) => {
    setViewingJobs(row)
    exportAsPdf(statementRef?.current, `PaydayStatement-${row?.id || "1"}.pdf`);
  };

  return (
    <>
      <PageHeader name="Driver Statement" />
      <div className="main-container container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card custom-card">
              <div className="card-header w-100">
                <div className="row w-100 m-0">
                  <div className="col-auto p-0 d-flex">
                    <Button
                      className="btn btn-primary"
                      onClick={() => {
                        setShowCreateModal(true)
                        setIsEdit(null)
                      }}
                    >
                      Create Pay Day
                    </Button>
                  </div>
                  <div className="col-auto p-0 ms-2">
                    <Button
                      className="btn btn-primary"
                      onClick={() => setOpen(!open)}
                      aria-controls="collapse-inputs"
                      aria-expanded={open}
                    >
                      <i className="ri-filter-2-fill" />
                    </Button>
                  </div>
                  <div className="col-lg-3 col-5 p-0 ms-auto">
                    <div className="input-group m-0">
                      <span className="input-group-text bg-transparent border text-primary">
                        <i className="ri-search-line" />
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search Here..."
                        value={searchQuery}
                        onKeyUp={(e) => onSearchKeyHandler(e)}
                        onChange={(e) => setSearchQuery(e.target?.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <Collapse in={open}>
                <div className="w-100">
                  <Filter setQuery={setQuery} />
                </div>
              </Collapse>

              <div className="card-body">
                <CustomPagination
                  isFetching={isFetching}
                  data={statements}
                  total={total}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handlePerPageChange}
                  paginationDefaultPage={currentPage}
                  columns={[
                    {
                      name: "Payday #",
                      selector: (row) => row.id,
                      sortable: true,
                    },
                    {
                      name: "Driver",
                      cell: (row) => (
                        <>
                          {row?.driver?.full_name}
                        </>
                      ),
                      sortable: true,
                    },
                    {
                      name: "Jobs",
                      cell: (row) => (
                        <Button
                          variant="link"
                          className="p-0"
                          onClick={() => {
                            setViewingJobs(row?.jobs);
                            setShowJobsModal(true);
                          }}
                        >
                          {row.jobs?.length} jobs
                        </Button>
                      ),
                      sortable: false,
                    },
                    {
                      name: "Date Paid",
                      selector: (row) => row.paid_date,
                      sortable: true,
                    },
                    {
                      name: "Total Gross",
                      selector: (row) => `$${row?.jobs?.reduce((sum, job) => sum + (Number(job?.job?.job_amount) || 0), 0).toFixed(2) ?? '0'}`,
                      sortable: true,
                    },
                    {
                      name: "Total Expenses",
                      selector: (row) => `$${(JSON.parse(row.expenses) || [])?.reduce((sum, e) => sum + Number(e.amount), 0).toFixed(2) ?? '0'}`,
                      sortable: true,
                    },
                    {
                      name: "Net Earnings",
                      selector: (row) => {
                        const gross_earning = row?.jobs?.reduce((sum, job) => sum + (Number(job?.job?.job_amount) || 0), 0)
                        const total_expense = (JSON.parse(row?.expenses) || [])?.reduce((sum, e) => sum + Number(e.amount), 0)
                        return `$${parseInt(gross_earning - total_expense)?.toFixed(2) ?? ''} `;
                      },
                      sortable: true,
                    },
                    {
                      name: "Status",
                      cell: (row) => (
                        <span
                          className={`badge ${row?.is_paid === "PAID" ? "bg-success" : "bg-danger"
                            }`}
                        >
                          {row?.is_paid}
                        </span>
                      ),
                      sortable: true,
                    },
                    {
                      name: "Actions",
                      cell: (row) => (
                        <div className="hstack gap-1 fs-1">
                          <button
                            onClick={() => handleDownloadPdf(row)}
                            className="btn btn-icon btn-sm btn-success-light"
                          >
                            <i class="ri-download-fill" />
                          </button>
                          <button
                            onClick={() => {
                              setViewingPayday(row);
                              setShowViewModal(true);
                            }}
                            className="btn btn-icon btn-sm btn-primary-light"
                          >
                            <i className="ri-eye-fill" />
                          </button>

                          <button
                            onClick={() => {
                              setShowCreateModal(true)
                              setIsEdit(row)
                            }}
                            className="btn btn-icon btn-sm btn-info-light"
                          >
                            <i className="ri-pencil-line" />
                          </button>
                          <a
                            aria-label="delete"
                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                          >
                            <i className="ri-delete-bin-7-line" />
                          </a>
                        </div>
                      ),
                      ignoreRowClick: true,
                      allowOverflow: true,
                      button: true,
                      width: "220px",
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- MODALS --- */}
      {(showCreateModal && !isEdit) && (
        <CreatePaydayModal
          show={showCreateModal}
          onHide={() => setShowCreateModal(false)}
        />
      )}
      {(showCreateModal && isEdit) && (
        <EditPayDayModal
          show={showCreateModal}
          onHide={() => setShowCreateModal(false)}
          isEdit={isEdit}
        />
      )}

      {showViewModal && (
        <ViewPaydayModal
          show={showViewModal}
          onHide={() => setShowViewModal(false)}
          data={viewingPayday}
        />
      )}

      {showJobsModal && (
        <JobsModal
          show={showJobsModal}
          onHide={() => setShowJobsModal(false)}
          jobs={viewingJobs}
        />
      )}

      {showDocModal && (
        <DocModal
          show={showDocModal}
          onHide={() => setShowDocModal(false)}
          title={docModal.title}
          content={docModal.content}
        />
      )}


      
      <PaydayStatement ref={statementRef} data={viewingJobs}  />
    </>
  );
};

export default DriverStatement;